import React, { useEffect, useState } from "react";
import Loader from "../../components/shared/Loader";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { updateMeta } from "../../store/actions/metaAction";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import cookie from "js-cookie";
import server, { uploadServer } from "../../api/server";
import { v4 } from "uuid";
import ReactQuill from "react-quill";

import { Controller } from "react-hook-form";
import { toast } from "react-toastify";

const PrivacyIndex = ({ match }) => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [loading, setLoading] = useState(false);
	const [currentInfo, setCurrentInfo] = useState({});
	const dispatch = useDispatch();

	const {
		params: { aboutUsSectionId },
	} = match;

	const {
		register,
		handleSubmit,
		watch,
		formState: { errors },
		setValue,
		getValues,
		control,
		reset,
	} = useForm();
	const { append, remove, fields } = useFieldArray({
		name: "extraInfo",
		control,
	});
	const [pictureImg, setPictureImg] = useState(userPlaceholder);
	const quillModules = {
		toolbar: [
			[{ header: [1, 2, false] }],
			["bold", "italic", "underline", "strike"],
			[{ align: [] }],
			[{ list: "ordered" }, { list: "bullet" }],
			["blockquote", "code-block"],
			["link", "image", "video"],
			["clean"],
		],
	};

	const quillFormats = [
		"header",
		"bold",
		"italic",
		"underline",
		"strike",
		"align",
		"list",
		"blockquote",
		"code-block",
		"direction",
		"link",
		"image",
		"video",
	];
	const onStart = async () => {
		dispatch(
			updateMeta({
				title: "اضافة فئة جديدة",
				breadcrumb: "الفئات",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		try {
			const initialData = await server(cookie).get(`/pages/privacy/sections`);
			console.log(
				initialData?.data?.data?.sections[0]?.description.ar,
				"inyyyy"
			);

			reset({
				description: {
					ar: initialData?.data?.data?.sections[0]?.description.ar,
					en: initialData?.data?.data?.sections[0]?.description.en,
				},
			});
		} catch (error) {
			console.log(error);
		}
	};

	// handleMethods
	const submitHandler = async data => {
		setLoading(true);
		try {
			const { picturePath, pictureUrl, ...finalData } = {
				...data,
				title: "privacy",
			};

			const dataResponse = await server(cookie).put(
				`/pages/privacy/sections/privacy-1`,
				{
					section: finalData,
				}
			);
			toast.success("تم تعديل البيانات بنجاح");

			onStart();
		} catch (error) {
			console.log(error);
		}
		setLoading(false);
	};

	// watchers
	useEffect(() => {
		onStart();
	}, []);

	console.log(errors);

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit(submitHandler)}>
				<div className="row">
					<div className="col-md-">
						<div className="card">
							<div className="row mb-3">
								{/* Arabic About Company */}
								<div className="col-xs-12 col-md-12 mb-5 col-lg-6 col-sm-12">
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="descriptionAr">
												سياسه الخصوصيه باللغه العربيه
											</label>
											<Controller
												name="description.ar"
												control={control}
												// rules={{ required: true }}
												render={({ field }) => (
													<ReactQuill
														{...field}
														theme="snow"
														id="descriptionEn"
														// placeholder="Enter about description..."
														modules={quillModules}
														formats={quillFormats}
													/>
												)}
											/>
										</div>
									</div>
								</div>

								{/* English About Company */}
								<div className="col-xs-12 col-md-12 mb-5 col-lg-6 col-sm-12">
									<div className="card-body">
										<div className="form-item">
											<label htmlFor="descriptionEn">
												سياسه الخصوصيه باللغه الانجليزيه
											</label>
											<Controller
												name="description.en"
												control={control}
												// rules={{ required: true }}
												render={({ field }) => (
													<ReactQuill
														{...field}
														theme="snow"
														id="descriptionEn"
														// placeholder="Enter vision description..."
														modules={quillModules}
														formats={quillFormats}
													/>
												)}
											/>
										</div>
									</div>
								</div>
							</div>

							<div className="form-item mt-3 w-100 d-flex justify-content-center">
								<button className="bt bt-success btn-block w-50">ارسال</button>
							</div>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default PrivacyIndex;
